import { load } from 'recaptcha-v3'
import {
	type reCaptchaSettings,
	type Form,
	type reCaptchaResponse,
} from '../../../types/graphql.form'

export const GreCAPTCHA_FORM_NAME = 'grecaptcha'

export async function reCaptcha(key: string): Promise<string> {
	const recaptcha = await load(key)
	return await recaptcha.execute('submit')
}

export function getReCaptchaSiteKey(form: Form) {
	const recaptchaSettings = form.settings.integrations.find(
		(i) => i.handle === 'recaptcha',
	)
	if (!recaptchaSettings || !recaptchaSettings.enabled) return false
	const settings = JSON.parse(recaptchaSettings?.settings) as reCaptchaSettings
	return settings.siteKey
}

export function getReCaptchaSettings(form: Form) {
	const recaptchaSettings = form.settings.integrations.find(
		(i) => i.handle === 'recaptcha',
	)
	if (!recaptchaSettings || !recaptchaSettings.enabled) return false
	const settings = JSON.parse(recaptchaSettings?.settings) as reCaptchaSettings
	return settings
}

export async function reCaptchaStatus(form: Form, formData: FormData) {
	const settings = getReCaptchaSettings(form)
	if (!settings) return true
	const reCaptchaValdiationUrl = `https://www.google.com/recaptcha/api/siteverify?secret=${
		settings.secretKey
	}&response=${formData.get(GreCAPTCHA_FORM_NAME)}`

	const reCaptchaRes = await fetch(reCaptchaValdiationUrl, {
		method: 'post',
	})
	const res = (await reCaptchaRes.json()) as reCaptchaResponse
	return !(res.success && res.score >= settings.minScore)
}
